import { Pipe, PipeTransform } from '@angular/core';
import { Person } from '../_models/person.model';

@Pipe({
  name: 'personDetails'
})
export class PersonDetailsPipe implements PipeTransform {

  /**
   * Transform person object to string with details 
   * @param user object based on user model
   * @returns string with user details
   */
  transform(user: Person): unknown {
    const none = '---';
    const suffix = '\n';

    if(user) {
      let details = [];
      
      details.push((user?.name ?? none));
      details.push((user?.lastName ?? none) + suffix);
      details.push((user?.email ?? none) + suffix);
      details.push(user?.company?.name);

      return details.join(' ');
    }
    return none;
  }

}
